import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';

import { CURRENT_YEAR } from '../../../lib/constants/date-time.constants';
import { SourceOfFundEnum } from '../../../lib/enums/source-of-fund.enum';
import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';
import { setSourceOfFundsIsEdit } from '../../../lib/store/crm';
import { getSourceOfFundsData } from '../../../lib/store/selectors';
import { getNameOfLenderValidity, validateControl } from '../../../lib/util/ValidationSchemes/Validate';

import AutocompleteControl from '../../AutocompleteControl/AutocompleteControl';
import InputControl from '../../InputControl/InputControl';
import { IOption } from '../../SelectControl/SelectControl.types';
import { GeneralQuestionsCustomAnswers } from '../EnrollGeneralQuestions/EnrollGeneralQuesions.types';
import {
  KEY_SOURCE_OF_FUND_FROM,
  KEY_SOURCE_OF_FUND_IDENTITY_NAME,
  KEY_SOURCE_OF_FUND_TO,
  KEY_SOURCE_OF_FUND_TYPE,
} from '../EnrollGeneralQuestions/EnrollGeneralQuestions.constants';
import YearDatePicker from '../YearDatePicker/YearDatePicker';

import styles from '../EnrollSourceOfFunds/EnrollSourceOfFunds.module.scss';

const values = lang.commonSourceOfFundsLoanTypes().split(',');
const options: IOption[] = values.map(value => ({
  value,
  label: value,
}));

type ReduxStateProps = {
  sourceOfFunds?: any;
  isEditSourceOfFunds?: boolean;
  isClickedBtnContinue: boolean;
}

type Props = {
  formData: GeneralQuestionsCustomAnswers;
  handleChange: (formKey: string, value: string | number) => void;
} & ReduxStateProps

const EnrollLoan = ({
  formData,
  handleChange,
  sourceOfFunds,
  isEditSourceOfFunds,
  isClickedBtnContinue,
}: Props):JSX.Element => {
  const [customData, setCustomData] = useState(formData);
  const dispatch = useDispatch();

  const datePickerFromYear = customData[KEY_SOURCE_OF_FUND_FROM] as string || undefined;
  const datePickerToYear = customData[KEY_SOURCE_OF_FUND_TO] as string || CURRENT_YEAR.toString();

  if (sourceOfFunds && !isEditSourceOfFunds) {
    customData[KEY_SOURCE_OF_FUND_FROM] = sourceOfFunds.from;
    customData[KEY_SOURCE_OF_FUND_TO] = sourceOfFunds.to;
    customData[KEY_SOURCE_OF_FUND_IDENTITY_NAME] = sourceOfFunds.identity_name;
    customData[KEY_SOURCE_OF_FUND_TYPE] = sourceOfFunds.fund_type;
    dispatch(setSourceOfFundsIsEdit(true));
    handleChange('', '');
  }

  return (
    <div className={styles.wrapper}>
      <YearDatePicker
        formErrors={isClickedBtnContinue
          ? validateControl(
            datePickerFromYear as string,
            [],
            lang.commonSourceOfFundsDateFromLabel(),
            true,
          ).errors
          : []}
        datePickerToYear={datePickerToYear}
        datePickerFromYear={datePickerFromYear}
        handleChange={handleChange}
        setCustomData={setCustomData}
      />
      <Row className={styles.row}>
        <Col md={12}>
          <AutocompleteControl
            isReadOnly
            id="enrollLoan"
            options={options}
            placeholder={lang.commonSourceOfFundsLenderType()}
            value={customData[KEY_SOURCE_OF_FUND_TYPE] as string}
            onValueChanged={(value: string | number) => {
              setCustomData((currentState: GeneralQuestionsCustomAnswers) => ({
                ...currentState,
                [KEY_SOURCE_OF_FUND_TYPE]: value,
              }));
            }}
            onBlur={(value: string | number | null) => {
              value && handleChange(KEY_SOURCE_OF_FUND_TYPE, value);
            }}
            errors={isClickedBtnContinue
              ? validateControl(
                customData[KEY_SOURCE_OF_FUND_TYPE],
                [],
                lang.commonSourceOfFundsLenderType(),
                true,
              ).errors
              : []}
          />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col md={12}>
          <InputControl
            name=""
            placeholder=""
            id="nameLender"
            ariaLabel="name of lender"
            label={lang.commonSourceOfFundsLenderNameLabel()}
            value={customData[KEY_SOURCE_OF_FUND_IDENTITY_NAME] as string}
            onBlur={(value: string | number) => {
              handleChange(KEY_SOURCE_OF_FUND_IDENTITY_NAME, value);
            }}
            onValueChange={(value: string | number) => {
              setCustomData((currentState: GeneralQuestionsCustomAnswers) => ({
                ...currentState,
                [KEY_SOURCE_OF_FUND_IDENTITY_NAME]: value,
              }));
            }}
            errors={isClickedBtnContinue
              ? getNameOfLenderValidity(customData[KEY_SOURCE_OF_FUND_IDENTITY_NAME] as string).errors
              : []}
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state: RootState): any => ({
  sourceOfFunds: getSourceOfFundsData(state, SourceOfFundEnum.LoanAlaric),
  isEditSourceOfFunds: state.crm.enroll.isEditSourceOfFunds,
});

export default connect(mapStateToProps)(EnrollLoan);
